import styled from 'styled-components';

export const ContainerCards = styled.div`
  display: flex;
  flex-direction: column;
  width: 89.333vw;
  gap: 3vw;
  margin-top: 2vw;

  h1 {
    font-size: 5.866vw;
    font-weight: 700;
    margin: 5.066vw 0 1.6vw 0;
  }
`;

export const Card = styled.div<{ border: string }>`
  border: ${(props) => props.border};
  border-radius: 2vw;
  width: 100%;
  height: 25vw;
  display: flex;
  justify-content: flex-start;
  gap: 4vw;
  align-items: center;
  position: relative;
`;

export const CreditCardIcon = styled.img`
  width: 5.4vw;
  height: 4.2vw;
  margin: 0 1.84vw 0 4.24vw;
`;

export const CardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2vw;

  p {
    margin: 0;
  }
`;

export const TrashIcon = styled.img`
  width: 3.5vw;
  height: 4.4vw;
  background-color: transparent;
`;

export const CheckIcon = styled.img`
  width: 6.5vw;
  height: 8.4vw;
  background-color: transparent;
`;

export const IconContainer = styled.button`
  width: 7.5vw;
  height: 7.5vw;
  display: flex;
  flex: none;
  justify-content: center;
  align-items: center;
  background-color: black;
  position: absolute;
  right: -2.5vw;
  top: -2.5vw;
  border-radius: 10vw;
  border: none;

  &:disabled {
    cursor: not-allowed;
    background-color: #efefef;
    border: none;
  }
`;

export const LoadingGif = styled.img`
  background-color: transparent;
  width: 13.333vw;
  height: 13.333vw;
`;

export const Button = styled.button`
  font-family: 'Outfit', sans-serif;
  font-size: 4.266vw;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  color: #ffffff;
  width: 89.333vw;
  height: 13.333vw;
  border: 1px solid #000000;
  border-radius: 2.666vw;
  margin-top: 3vw;
  background-color: #000000;
  cursor: pointer;
  flex: none;

  &:disabled {
    cursor: not-allowed;
    background-color: #efefef;
    border: none;
  }
`;
